var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-auto rounded-lg flex flex-col overflow-hidden relative"},[_c('pipeline-status',{staticClass:"mt-4",attrs:{"isMobile":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }